<div class="p-20">
  <form [formGroup]="aiPolicyForm">
    <div class="row">
      <div class="col-md-12">
        <h3 class="page-header">AI Policy Settings</h3>
        <p>Configure AI features for your organization.</p>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <mat-slide-toggle formControlName="enableAI" color="primary">
          Enable AI
        </mat-slide-toggle>
        <p class="text-muted">
          Master switch to enable or disable all AI features
        </p>
      </div>
    </div>

    <div *ngIf="aiPolicyForm.get('enableAI').value">
      <hr />
      
      <div class="row">
        <div class="col-md-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>LLM Provider</mat-label>
            <mat-select formControlName="llm">
              <mat-option *ngFor="let option of llmOptions" [value]="option">
                {{ option }}
              </mat-option>
            </mat-select>
            <mat-hint>Select the Large Language Model provider</mat-hint>
          </mat-form-field>
        </div>
      </div>

      <hr />

      <div class="row">
        <div class="col-md-12">
          <h4>AI Features</h4>
          <p class="text-muted">Enable specific AI capabilities for your organization</p>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <mat-checkbox formControlName="askQuestionsToData" color="primary">
            Ask Questions to Your Data
          </mat-checkbox>
          <p class="text-muted small">
            Use AI to query and analyze your survey data with natural language questions
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <mat-checkbox formControlName="commentClassification" color="primary">
            Comment Classification
          </mat-checkbox>
          <p class="text-muted small">
            Automatically classify and categorize survey comments using AI
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <mat-checkbox formControlName="sentimentAnalysis" color="primary">
            Sentiment Analysis
          </mat-checkbox>
          <p class="text-muted small">
            Analyze the sentiment and emotional tone of survey responses
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <mat-checkbox formControlName="analyzeCommentsLegality" color="primary">
            Analyze Comments for Legality
          </mat-checkbox>
          <p class="text-muted small">
            Detect potential legal issues or compliance concerns in comments
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <mat-checkbox formControlName="translateCommentsToEnglish" color="primary">
            Translate Comments to English
          </mat-checkbox>
          <p class="text-muted small">
            Automatically translate non-English comments to English for easier analysis
          </p>
        </div>
      </div>
    </div>
  </form>
</div>
